'use strict';
var $ = jQuery;

(function ($) {

    const players = Plyr.setup('.werk-audio-control', {
        settings: [],
    });
 
    /* Single setup
    const player = new Plyr('.werk-audio-control', {
       
        settings: ['loop'],
    });
    */
   
})(jQuery);

